import { getUserToken } from '@/functions.js'
import { getServerApi } from '@/config/deployment'
import { performRequest_GET, performRequest_POST, performRequest_PUT } from '@/platform/utils/http/httpService'
import { makeDealUpdate } from './transformer/dealExportTransformer.js'
let envUri = getServerApi()
let dealsUri = envUri + '/api/deals'

export const getPropertyDeals = ({propertyId, accountId})=>{
  return new Promise((resolve, reject) => {
    getUserToken()
      .then(token => {
        var headers = { "Authorization": token };
        performRequest_GET(dealsUri + "/property/" + propertyId, {}, headers)
          .then(resp => {
            if (resp.success) resolve(resp.response.data.body)
            else reject(resp.error)
          })
          .catch(err => {
            console.log("getDealSnapshots | err:", err)
            reject(err)
          })
      })
  })
}

export const getDealSnapshots = ({ dealId }) => {
  return new Promise((resolve, reject) => {
    getUserToken()
      .then(token => {
        var headers = { "Authorization": token };
        performRequest_GET(dealsUri + "/" + dealId + "/snapshots", {}, headers)
          .then(resp => {
            if (resp.success) resolve(resp.response.data.body)
            else reject(resp.error)
          })
          .catch(err => {
            console.log("getDealSnapshots | err:", err)
            reject(err)
          })
      })
  })
}

export const createDealSnapshot = ({ dealId, snapshot, comment, accountId, inEffectDate }) => {
  return new Promise((resolve, reject) => {
    getUserToken()
      .then(token => {
        var headers = { "Authorization": token };
        var data = {
          dealId: dealId,
          dealSnapshot: snapshot,
          comment: comment,
          accountId: accountId,
          inEffectDate: inEffectDate
        }

        return performRequest_POST(dealsUri + "/snapshot", data, headers)
      })
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        console.log("createDealSnapshot | err:", err)
        reject(err)
      })
  })
}

export const updateDeal = ({updatePayload, accountId}) => {
  return new Promise((resolve, reject) => {
    var headers
    getUserToken()
      .then(token => {
        headers = { "Authorization": token };
        return performRequest_PUT(dealsUri+"?accountId="+accountId, makeDealUpdate(updatePayload), headers)
      })
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        console.log("updateDeal | err:", err)
        reject(err)
      })
  })

}






// WEBPACK FOOTER //
// ./src/platform/deals/services/dealsService.js